import { render, staticRenderFns } from "./orders3.vue?vue&type=template&id=26f43f5c&scoped=true&"
import script from "./orders3.vue?vue&type=script&lang=js&"
export * from "./orders3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f43f5c",
  null
  
)

export default component.exports